import SmoothScroll from 'smoothscroll-polyfill';

// SmoothScroll polyfill for Edge
SmoothScroll.polyfill();



// WEBPACK FOOTER //
// ./src/polyfills.js